module.exports = "//static.hsappstatic.net/salesImages/static-1.403/prospects/stream-opt-in-confetti.png"